import { combineReducers } from 'redux';

import compateReducer from './compare-reducer';
import { autoMarksReducer } from './autoMarksReducer';
import { autoModelsReducer } from './autoModelsReducer';
import { autoFuelsReducer } from './autoFuelsReducer';
import { autoTransmissionsReducer } from './autoTransmissionsReducer';
import { regionsReducer } from './regionsReducer';
import { citiesReducer } from './citiesReducer';
import { autoDataReducer } from './autoDataReducer';
import { offersReducer } from './offersReducer';

export const rootReducer = combineReducers({
  compareState: compateReducer,
  autoMarks: autoMarksReducer,
  autoModels: autoModelsReducer,
  autoFuels: autoFuelsReducer,
  autoTransmissions: autoTransmissionsReducer,
  regions: regionsReducer,
  cities: citiesReducer,
  autoData: autoDataReducer,
  offers: offersReducer
});
